import TtamCreativeToolInOne from './creative-tool-in-one.vue';
import * as hooks from './hooks';
export default {
  TtamCreativeToolInOne,
  ...hooks,
};
